import React from 'react';
import {
  ChildrenWrapper,
  ContentWrapper,
  LeftBlock,
  RightBlock,
  Root,
} from './DualScrollWrapper.styles';

export interface DualScrollWrapperProps {
  /**
   * Content to display in the left sidebar
   */
  leftSidebar: React.ReactNode;
  /**
   * Whether to use fixed sidebar width
   */
  fixedSidebar?: boolean;
  /**
   * Children content to display in the main area
   */
  children: React.ReactNode;
  /**
   * Additional CSS classes
   */
  className?: string;
}

const DualScrollWrapper: React.FC<DualScrollWrapperProps> = ({
  leftSidebar,
  fixedSidebar = false,
  children,
  className,
}) => {
  return (
    <Root className={className}>
      <ContentWrapper $fixedSidebar={fixedSidebar}>
        <LeftBlock>{leftSidebar}</LeftBlock>
        <RightBlock>
          <ChildrenWrapper>{children}</ChildrenWrapper>
        </RightBlock>
      </ContentWrapper>
    </Root>
  );
};

export default DualScrollWrapper;
